// extracted by mini-css-extract-plugin
export default {"title":"Title_title__iSOaq","container":"Title_container__fO52P"};